import { useEffect } from 'react';

// Evento personalizado para notificar sobre atualizações de avatar
const AVATAR_UPDATE_EVENT = 'avatar-update';

// Interface para os dados do evento
interface AvatarUpdateEventData {
  userId: string;
  avatarUrl: string;
  timestamp: number;
}

/**
 * Hook para emitir um evento de atualização de avatar
 */
export const useEmitAvatarUpdate = () => {
  const emitAvatarUpdate = (userId: string, avatarUrl: string) => {
    // Criamos um evento personalizado com os dados da atualização
    const event = new CustomEvent<AvatarUpdateEventData>(AVATAR_UPDATE_EVENT, {
      detail: {
        userId,
        avatarUrl,
        timestamp: Date.now()
      }
    });
    
    // Disparamos o evento no documento
    document.dispatchEvent(event);
    console.log('[useAvatarUpdateEvent] Evento de atualização de avatar emitido:', { userId, avatarUrl });
  };

  return { emitAvatarUpdate };
};

/**
 * Hook para escutar eventos de atualização de avatar
 * @param userId ID do usuário para filtrar (opcional)
 * @param callback Função a ser chamada quando o evento ocorrer
 */
export const useListenAvatarUpdate = (
  userId: string | undefined,
  callback: (data: AvatarUpdateEventData) => void
) => {
  useEffect(() => {
    // Handler para o evento
    const handleAvatarUpdate = (event: Event) => {
      const customEvent = event as CustomEvent<AvatarUpdateEventData>;
      const data = customEvent.detail;
      
      // Se um userId foi especificado, filtramos os eventos
      if (userId && data.userId !== userId) {
        return;
      }
      
      // Chamamos o callback com os dados do evento
      callback(data);
      console.log('[useAvatarUpdateEvent] Evento de atualização de avatar recebido:', data);
    };
    
    // Registramos o listener
    document.addEventListener(AVATAR_UPDATE_EVENT, handleAvatarUpdate);
    
    // Limpeza ao desmontar
    return () => {
      document.removeEventListener(AVATAR_UPDATE_EVENT, handleAvatarUpdate);
    };
  }, [userId, callback]);
};
